import { CustomFormBlock } from "@/types";

export const getSelectedOptionIds = (
  question: CustomFormBlock | null | undefined,
  answer: unknown,
): number[] => {
  const options = question?.attributes?.options ?? [];

  if (!answer || typeof answer !== "object" || !("answer" in answer)) {
    return [];
  }

  const rawAnswer = answer.answer;

  const values = Array.isArray(rawAnswer)
    ? rawAnswer
    : typeof rawAnswer === "string"
      ? [rawAnswer]
      : [];

  return values.flatMap((value) => {
    const option = options.find((option) => option.value === value);

    return option ? [Number(option.id)] : [];
  });
};
